import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import Loadable from 'react-loadable';

import Spinner from '@stubhub/react-spinner';

import GeneralAdmissionBanner from '../../components/react-general-admission-banner';
import {NoListingEvent} from '../react-no-listings';

const SeatMapMapbox = Loadable({
  loader: () =>
    import(/* webpackChunkName: "event-seat-map" */ '../../containers/react-seat-map-mapbox/seatMapQueryParamWrapper'),
  loading: Spinner,
});

export default class RoyalMapView extends PureComponent {
  render() {
    const {
      eventId,
      hasTickets = false,
      listingLoading = true,
      loaded = false,
      isGA,
      listingInfo,
      mapValue,
      mapboxPreviewMode,
      device,
      goBack,
      handleCloseBYO,
    } = this.props;

    if (!hasTickets && !listingLoading) {
      return <NoListingEvent eventId={eventId} goBack={goBack} />;
    }

    if (loaded) {
      if (isGA) {
        return <GeneralAdmissionBanner />;
      }

      return (
        <SeatMapMapbox
          type={mapValue ? mapValue : 'section'}
          eventId={eventId}
          onCloseTooltip={handleCloseBYO}
          mapboxMode={mapboxPreviewMode ? 'preview' : ''}
          device={device}
          listingInfo={listingInfo}
        />
      );
    }

    return null;
  }
}

RoyalMapView.propTypes = {
  /**
   * Device type
   */
  device: PropTypes.oneOf(['phone', 'desktop']).isRequired,

  /**
   * Event ID
   */
  eventId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  /**
   * If event has tickets
   */
  hasTickets: PropTypes.bool,

  /**
   * If listing is loading
   */
  listingLoading: PropTypes.bool,

  /**
   * If map is loaded
   */
  loaded: PropTypes.bool,

  /**
   * If is general admission
   */
  isGA: PropTypes.bool,

  /**
   * Listing details
   */
  listingInfo: PropTypes.object,

  /**
   * Map value
   */
  mapValue: PropTypes.string,

  /**
   * If is preview mode enabled
   */
  mapboxPreviewMode: PropTypes.bool,

  /**
   * Go back function
   */
  goBack: PropTypes.func,

  /**
   * On close function
   */
  handleCloseBYO: PropTypes.func,
};
